import request from '../../utils/request';

// 线索池分页查询  跟进任务查询  
export function getLeadsPool(params,Authorization) {
  return request({
    url: '/api/leads-pool/query',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
    
  })
}
// 获取客户详情
export function getCustomerDetails(params,Authorization) {
  return request({
    url: '/api/leads-pool/getCustomerDetails',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
    
  })
}
// 添加跟进人
export function addfollower(params,Authorization) {
  return request({
    url: '/api/leads-pool/updatefollower',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 查询跟进历史
export function getfollowerhistory(id,Authorization) {
  return request({
    url: '/api/chatMaterial/'+id,
    method: 'delete',
    headers: {
      "authorization": Authorization
    }
  })
}

// 添加备注
export function addRemark(params,Authorization) {
  return request({
    url: '/api/leads-pool/addremark',
    method: 'post',
    data:params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 转化效果
export function getChart(params,Authorization) {
  return request({
    url: '/api/leads-pool/statisticstranslateeffect',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 短信群发新增
export function statisticsList(params,Authorization) {
  return request({
    url: '/api/leads-pool/statisticslist',
    method: 'get',
    params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 客户群发-统计选中的客户数量
export function countCus(params,Authorization) {
  return request({
    url: '/api/msg/task/countCus',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization
    }
  })
}
// 客户群发-获取标签
export function getTags(Authorization) {
  return request({
    url: '/api/msg/task/tags',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}
// 批量上传文件
export function savefile(params,Authorization) {
  return request({
    url: '/api/chatMaterial/saveFile',
    method: 'post',
    data: params,
    headers: {
      "authorization": Authorization,
      'Content-Type': 'multipart/form-data'
    }
  })
}